/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Organisation
 */
export interface Organisation {
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  kvkNumber: string;
}

export interface FullOrganisation {
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  kvkNumber: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  broUserToken?: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  broUserPassword?: string;
}

/**
 * Check if a given object implements the Organisation interface.
 */
export function instanceOfOrganisation(value: object): value is Organisation {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("kvkNumber" in (value as Record<string, any>)) &&
      !("kvk_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["kvkNumber"] === undefined &&
      (value as Record<string, any>)["kvk_number"] === undefined)
  )
    return false;
  return true;
}

export function OrganisationFromJSON(json: any): Organisation {
  return OrganisationFromJSONTyped(json, false);
}

export function OrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organisation {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    kvkNumber: json["kvk_number"],
  };
}

export function OrganisationToJSON(json: any): Organisation {
  return OrganisationToJSONTyped(json, false);
}

export function OrganisationToJSONTyped(
  value?: Organisation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    kvk_number: value["kvkNumber"],
  };
}

export function FullOrganisationFromJSON(json: any): FullOrganisation {
  return FullOrganisationFromJSONTyped(json, false);
}

export function FullOrganisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FullOrganisation {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    kvkNumber: json["kvk_number"],
    broUserToken: json["bro_user_token"],
    broUserPassword: json["bro_user_password"],
  };
}

export function FullOrganisationToJSON(json: any): FullOrganisation {
  return FullOrganisationToJSONTyped(json, false);
}

export function FullOrganisationToJSONTyped(
  value?: FullOrganisation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    kvk_number: value["kvkNumber"],
    bro_user_token: value["broUserToken"],
    bro_user_password: value["broUserPassword"],
  };
}
